import { render, staticRenderFns } from "./FixedFooter.vue?vue&type=template&id=6c5ae370&scoped=true"
import script from "./FixedFooter.vue?vue&type=script&lang=js"
export * from "./FixedFooter.vue?vue&type=script&lang=js"
import style0 from "./FixedFooter.vue?vue&type=style&index=0&id=6c5ae370&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5ae370",
  null
  
)

export default component.exports